// AdminSettings.js
import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Save, Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';

export default function AdminSettings() {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { api.get('/admin/settings').then(r => setCompany(r.data)); }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      await api.put('/admin/settings', { name: company.name, settings: company.settings });
      toast.success('Paramètres sauvegardés');
    } catch { toast.error('Erreur'); } finally { setLoading(false); }
  };

  if (!company) return <div className="flex items-center justify-center h-64"><Loader2 className="w-6 h-6 animate-spin text-blue-500" /></div>;

  const setSetting = (key, value) => setCompany(prev => ({ ...prev, settings: { ...prev.settings, [key]: value } }));

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Paramètres</h1>
      <div className="space-y-5">
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
          <h2 className="font-semibold text-gray-700 mb-4">Informations organisation</h2>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1.5">Nom de l'organisation</label>
            <input value={company.name} onChange={e => setCompany(p => ({...p, name: e.target.value}))}
              className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none" />
          </div>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
          <h2 className="font-semibold text-gray-700 mb-4">Règles de pointage</h2>
          <div className="space-y-4">
            <label className="flex items-center justify-between">
              <div>
                <p className="font-medium text-gray-700 text-sm">Exiger GPS</p>
                <p className="text-gray-400 text-xs">Requiert la localisation pour pointer</p>
              </div>
              <input type="checkbox" checked={company.settings.requireGPS} onChange={e => setSetting('requireGPS', e.target.checked)} className="w-5 h-5 text-blue-600 rounded cursor-pointer" />
            </label>
            <label className="flex items-center justify-between">
              <div>
                <p className="font-medium text-gray-700 text-sm">Exiger reconnaissance faciale</p>
                <p className="text-gray-400 text-xs">Authentification biométrique obligatoire</p>
              </div>
              <input type="checkbox" checked={company.settings.requireFace} onChange={e => setSetting('requireFace', e.target.checked)} className="w-5 h-5 text-blue-600 rounded cursor-pointer" />
            </label>
            <label className="flex items-center justify-between">
              <div>
                <p className="font-medium text-gray-700 text-sm">Autoriser mobile</p>
                <p className="text-gray-400 text-xs">Pointage depuis l'application mobile</p>
              </div>
              <input type="checkbox" checked={company.settings.allowMobile} onChange={e => setSetting('allowMobile', e.target.checked)} className="w-5 h-5 text-blue-600 rounded cursor-pointer" />
            </label>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1.5">Rayon géofencing par défaut (m)</label>
              <input type="number" value={company.settings.gpsRadius} onChange={e => setSetting('gpsRadius', parseInt(e.target.value))} min={10} max={5000}
                className="w-32 px-3 py-2 border border-gray-200 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none" />
            </div>
          </div>
        </div>
        <button onClick={handleSave} disabled={loading}
          className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white px-6 py-3 rounded-xl font-medium transition">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
          Sauvegarder
        </button>
      </div>
    </div>
  );
}
